module.exports = __webpack_public_path__ + "static/media/LOMH_MENU-normal.6154d3c1.png";